import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { venammAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type SellVenammNftProps = {
  chainId: number
  config: Config
  venAmmAddress: Address
  account: Address
  tokenId: number
}

export const sellVenammNft = async ({
  chainId,
  config,
  venAmmAddress,
  account,
  tokenId,
}: SellVenammNftProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: venammAbi as Abi,
        account,
        address: venAmmAddress,
        args: [BigInt(tokenId)],
        chainId,
        functionName: "sell",
      },
    })
    return result
  } catch (error: any) {
    console.error("sellVenammNft", error)
    return { success: false, error: error.message, code: error.code }
  }
}

